import { ReactComponent as IconChauffageBois } from "../img/icons/infos/chauffage_bois.svg";
import { ReactComponent as IconChauffageElec } from "../img/icons/infos/chauffage_elec.svg";
import { ReactComponent as IconChauffageFuel } from "../img/icons/infos/chauffage_fuel.svg";
import { ReactComponent as IconChauffageGaz } from "../img/icons/infos/chauffage_gaz.svg";
import { ReactComponent as IconChauffagePac } from "../img/icons/infos/chauffage_pac.svg";
import { ReactComponent as IconDejaNon } from "../img/icons/infos/deja_non.svg";
import { ReactComponent as IconDejaOui } from "../img/icons/infos/deja_oui.svg";
import { ReactComponent as IconEauBallon } from "../img/icons/infos/eau_ballon.svg";
import { ReactComponent as IconEauFuel } from "../img/icons/infos/eau_fuel.svg";
import { ReactComponent as IconEauGaz } from "../img/icons/infos/eau_gaz.svg";
import { ReactComponent as IconEauPac } from "../img/icons/infos/eau_pac.svg";
import { ReactComponent as IconEauSolaire } from "../img/icons/infos/eau_solaire.svg";
import { ReactComponent as IconEauThermodynamique } from "../img/icons/infos/eau_thermodynamique.svg";
import { ReactComponent as IconElecInconnu } from "../img/icons/infos/elec_inconnu.svg";
import { ReactComponent as IconElecMono } from "../img/icons/infos/elec_mono.svg";
import { ReactComponent as IconElecTri } from "../img/icons/infos/elec_tri.svg";
import { ReactComponent as IconEquipementAucun } from "../img/icons/infos/equipement_aucun.svg";
import { ReactComponent as IconEquipementClim } from "../img/icons/infos/equipement_clim.svg";
import { ReactComponent as IconEquipementPiscine } from "../img/icons/infos/equipement_piscine.svg";
import { ReactComponent as IconEquipementVehiculeElec } from "../img/icons/infos/equipement_vehicule_elec.svg";
import { ReactComponent as IconFuturAucun } from "../img/icons/infos/futur_aucun.svg";
import { ReactComponent as IconFuturClim } from "../img/icons/infos/futur_clim.svg";
import { ReactComponent as IconFuturPiscine } from "../img/icons/infos/futur_piscine.svg";
import { ReactComponent as IconFuturVehicule } from "../img/icons/infos/futur_vehicule.svg";
import { ReactComponent as IconIncliAlsa } from "../img/icons/infos/incli_alsa.svg";
import { ReactComponent as IconIncliClassique } from "../img/icons/infos/incli_classique.svg";
import { ReactComponent as IconIncliMedi } from "../img/icons/infos/incli_medi.svg";
import { ReactComponent as IconIncliPlate } from "../img/icons/infos/incli_plate.svg";
import { ReactComponent as IconToitBonEtat } from "../img/icons/infos/toit_bon_etat.svg";
import { ReactComponent as IconToitMauvaisEtat } from "../img/icons/infos/toit_mauvais_etat.svg";
import { ReactComponent as IconToitEtatInconnu } from "../img/icons/infos/toit_etat_inconnu.svg";
import { ReactComponent as IconObjectifAutonomie } from "../img/icons/infos/objectif_autonomie.svg";
import { ReactComponent as IconObjectifBaisse } from "../img/icons/infos/objectif_baisse.svg";
import { ReactComponent as IconObjectifEcologie } from "../img/icons/infos/objectif_ecologie.svg";
import { ReactComponent as IconObjectifValorisation } from "../img/icons/infos/objectif_valorisation.svg";
import { ReactComponent as IconTypeAppartement } from "../img/icons/infos/type_appartement.svg";
import { ReactComponent as IconTypeAutre } from "../img/icons/infos/type_autre.svg";
import { ReactComponent as IconTypeMaison } from "../img/icons/infos/type_maison.svg";
import { ReactComponent as IconTypeTerrain } from "../img/icons/infos/type_terrain.svg";
import { ReactComponent as IconVousLocataire } from "../img/icons/infos/vous_locataire.svg";
import { ReactComponent as IconVousProprio } from "../img/icons/infos/vous_proprio.svg";

import ImageCompteurElectromecanique from "../img/icons/infos/compteur_electromecanique.png";
import ImageCompteurElectronique from "../img/icons/infos/compteur_electronique.png";
import ImageCompteurInconnu from "../img/icons/infos/compteur_inconnu.png";
import ImageCompteurLinky from "../img/icons/infos/compteur_linky.png";
import ImageToitArdoise from "../img/icons/infos/toit_ardoise.png";
import ImageToitAutre from "../img/icons/infos/toit_autre.png";
import ImageToitBacAcier from "../img/icons/infos/toit_bac_acier.png";
import ImageToitFibro from "../img/icons/infos/toit_fibro.png";
import ImageToitPlat from "../img/icons/infos/toit_plat.png";
import ImageToitTuilePlate from "../img/icons/infos/toit_tuile_plate.png";
import ImageToitTuile from "../img/icons/infos/toit_tuile.png";
import ImageToitZinc from "../img/icons/infos/toit_zinc.png";


const InfosQuestionnaire = [
    {
        key: 'vous',
        title: 'Vous êtes',
        type: 'choice',
        choices: [
            { label: 'Propriétaire', icon: IconVousProprio },
            { label: 'Locataire', icon: IconVousLocataire, info: '<b>Vous êtes locataire ?</b> Pas de souci, il suffit de passer un petit coup de fil à votre propriétaire, et on s\'occupe du reste !<br>👉 <a href="/contact">Contactez-nous pour échanger sur votre projet</a>' },
        ]
    },
    {
        key: 'type',
        title: 'Type d\'installation',
        type: 'choice',
        choices: [
            { label: 'Maison individuelle', key: 'maison', icon: IconTypeMaison },
            { label: 'Appartement', key: 'appartement', icon: IconTypeAppartement, exit: '<b>Pour info !</b> on n\'installe pas de panneaux solaire pour des appartements.<br>👉 <a href="/contact">Contactez-nous pour échanger sur votre projet</a>' },
            { label: 'Terrain ou jardin', key: 'terrain', icon: IconTypeTerrain },
            { label: 'Autre', key: 'autre', icon: IconTypeAutre, exit: '<b>Tente quechua ? Yourte ? Cabane ? Grotte ?</b> Désolé mais ce n\'est sans doute pas un panneau solaire qu\'il vous faut.<br>👉 <a href="/contact">Contactez-nous pour échanger sur votre projet</a>' },
        ]
    },
    {
        key: 'deja',
        title: 'Possédez vous déjà des panneaux solaires',
        type: 'choice',
        choices: [
            { label: 'Non', icon: IconDejaNon },
            { label: 'Oui', icon: IconDejaOui/*, exit: '<b>Un expert ? Parfait !</b> Le plus simple maintenant, c\'est de nous 👉 <a href="/contact">contacter directement</a>'*/ },
        ]
    },
    {
        key: 'age',
        title: 'Ancienneté habitation',
        type: 'choice',
        choices: [
            { label: '- de 2 ans' },
            { label: '+ de 2 ans' },
        ]
    },
    {
        key: 'surface',
        title: 'Superficie habitation',
        type: 'number',
        placeholder: '145 m²'
    },
    {
        key: 'etages',
        title: 'Etages habitation',
        type: 'number',
        placeholder: '2',
        max: 3,
        exit: '<b>Pour info !</b> Nous n\'installons pas de panneaux solaires sur les habitations de plus de 3 étages.<br>👉 <a href="/contact">Contactez-nous pour échanger sur votre projet</a>'
    },
    {
        key: 'toit',
        title: 'Type de toit',
        type: 'choice',
        choices: [
            { label: 'Ardoise', image: ImageToitArdoise },
            { label: 'Tuile canal', image: ImageToitTuile },
            { label: 'Tuile plate', image: ImageToitTuilePlate },
            { label: 'Toit plat (EPDM)', image: ImageToitPlat },
            { label: 'Bac acier', image: ImageToitBacAcier },
            { label: 'Zinc', image: ImageToitZinc },
            { label: 'Fibro-ciment', image: ImageToitFibro, exit: '<b>À noter</b> : nous n’installons pas de panneaux solaires sur les toitures en fibro-ciment.<br>En revanche, nous proposons une solution de remplacement adaptée : la toiture en bac acier.' },
            { label: 'Autre', image: ImageToitAutre, exit: '<b>Pour info !</b> Pas de pose possible pour les toitures en tige de botte (chaume) / toitures fibro amiante  / toitures en mauvaise état.  👉 <a href="/contact">Contactez-nous pour échanger sur votre projet</a>' },
        ],
        /*checkbox: { 
            label: 'Confirmer que votre toiture est en bon état !', 
            error: 'Mince ! vous avez oublié de cocher la case... c’est important pour évaluer votre devis, <br>si vous ne savez pas  👉 <a href="/contact">Contactez-nous pour échanger sur votre projet</a>'
        }*/
    },
    {
        key: 'etat',
        title: 'Etat de votre toiture',
        type: 'choice',
        choices: [
            { label: 'Ma toiture est suffisamment solide pour accueillir des panneaux solaires.', key: 'bon', icon: IconToitBonEtat },
            { 
                label: 'Ma toiture présente des signes d\'usure ou de vieillissement (infiltrations, tuiles abîmées, mousse, etc.)', 
                key: 'mauvais', 
                icon: IconToitMauvaisEtat,
                subchoices: {
                    label: 'Souhaitez-vous profiter de l\'intervention pour remplacer la couverture du toit ?',
                    key: 'changement_couverture',
                    choices: ['Oui', 'Non']
                }
            },
            { label: 'Je ne sais pas', key: 'inconnu', icon: IconToitEtatInconnu },
        ]
    },
    {
        key: 'inclinaison',
        title: 'Inclinaison',
        type: 'choice',
        choices: [
            { label: 'Plate (0°)', key: 0, icon: IconIncliPlate },
            { label: 'Méditerranéenne (15°)', key: 15, icon: IconIncliMedi },
            { label: 'Classique (30°)', key: 30, icon: IconIncliClassique },
            { label: 'Alsacienne (45°)', key: 45, icon: IconIncliAlsa },
        ]
    },
    {
        key: 'chauffage',
        title: 'Modes de chauffage',
        type: 'choice',
        multi: true,
        choices: [
            { label: 'Radiateurs électriques', icon: IconChauffageElec },
            { label: 'Pompe à chaleur', icon: IconChauffagePac },
            { label: 'Gaz', icon: IconChauffageGaz },
            { label: 'Fuel', icon: IconChauffageFuel },
            { label: 'Bois ou granulé', icon: IconChauffageBois },
        ]
    },
    {
        key: 'eau',
        title: 'Modes d\'eau chaude',
        type: 'choice',
        multi: true,
        choices: [
            { label: 'Ballon électrique', icon: IconEauBallon },
            { label: 'Pompe à chaleur', icon: IconEauPac },
            { label: 'Gaz', icon: IconEauGaz },
            { label: 'Fuel', icon: IconEauFuel },
            { label: 'Solaire', icon: IconEauSolaire },
            { label: 'Chauffe-eau thermodynamique', icon: IconEauThermodynamique },
        ]
    },
    {
        key: 'equipements',
        title: 'Equipements actuels',
        type: 'choice',
        multi: true,
        choices: [
            { label: 'Aucun équipement', key: 'aucun', icon: IconEquipementAucun },
            { label: 'Véhicule électrique', key: 've', icon: IconEquipementVehiculeElec },
            { label: 'Piscine ou Jacuzzi', key: 'piscine', icon: IconEquipementPiscine },
            { label: 'Climatisation', key: 'clim', icon: IconEquipementClim },
        ]
    },
    {
        key: 'equipements_futur',
        title: 'Equipements futurs',
        type: 'choice',
        multi: true,
        choices: [
            { label: 'Aucun projet futur', key: 'aucun', icon: IconFuturAucun },
            { label: 'Véhicule électrique', key: 've', icon: IconFuturVehicule },
            { label: 'Piscine ou Jacuzzi', key: 'piscine', icon: IconFuturPiscine },
            { label: 'Climatisation', key: 'clim', icon: IconFuturClim },
        ]
    },
    {
        key: 'elec_phase',
        title: 'Installation électrique',
        type: 'choice',
        choices: [
            { label: 'Monophasée Maximum à 12KW', key: 'mono', icon: IconElecMono },
            { label: 'Triphasée maximum à 36KW', key: 'tri', icon: IconElecTri },
            { label: 'Je ne sais pas', key: 'unknown', icon: IconElecInconnu },
        ]
    },
    {
        key: 'compteur',
        title: 'Compteur électrique',
        type: 'choice',
        choices: [
            { label: 'Electromécanique', image: ImageCompteurElectromecanique },
            { label: 'Electronique', image: ImageCompteurElectronique },
            { label: 'Intelligent (Linky)', image: ImageCompteurLinky },
            { label: 'Je ne sais pas', image: ImageCompteurInconnu },
        ]
    },
    {
        key: 'conso',
        title: 'Consommation d\'électricité',
        type: 'multinumber',
        choices: [
            { label: 'Mensuelle', key: 'consumption_monthly_euros', addend: '€ / mois' },
            { label: 'Annuelle', key: 'consumption_yearly_kw', addend: 'kWh / an' },
        ],
        /*alternate : {
            label: 'Je ne suis pas sûr', 
            choices: [
                { label: '0 à 125€' },
                { label: '125€ à 165€' },
                { label: '165€ à 210€' },
                { label: '+ de 210€' },
            ] 
        }*/
    },
    {
        key: 'contrat',
        title: 'Contrat électrique',
        type: 'choice',
        choices: [
            { label: 'Base' },
            { label: 'Heures pleines / heures creuses' },
            { label: 'Tempo' },
            { label: 'EJP' },
            { label: 'Je ne sais pas', info: '😎 pas grave ! mais votre estimation risque d\'être moins précise' },
        ]
    },
    {
        key: 'puissance',
        title: 'Quelle est la puissance souscrite en kVa (kilovoltampère)',
        type: 'choice',
        choices: [
            { label: '3 kVa', key: 3 },
            { label: '6 kVa', key: 6 },
            { label: '9 kVa', key: 9 },
            { label: '12 kVa', key: 12 },
            { label: '15 kVa', key: 15 },
            { label: '18 kVa', key: 18 },
            { label: 'Je ne sais pas', info: '😎 pas grave ! mais votre estimation risque d\'être moins précise' },
        ]
    },
    {
        key: 'objectif',
        header: '🌈 Dernière question !',
        title: 'Quel est votre principal objectif pour votre projet solaire ?',
        type: 'choice',
        choices: [
            { label: 'Baisser mes factures d\'électricité', key: 'economies', icon: IconObjectifBaisse },
            { label: 'Devenir autonome en énergie', key: 'autonomie', icon: IconObjectifAutonomie },
            { label: 'Augmenter la valeur de mon bien', key: 'valorisation', icon: IconObjectifValorisation },
            { label: 'Faire un geste pour la planète', key: 'ecologie', icon: IconObjectifEcologie },
        ],
    },
];

export default InfosQuestionnaire;